module.exports = "<p>\n  general-settings works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/System settings/general-settings/general-settings.component.html
// module id = ./src/app/Dashboard/DashboardPages/System settings/general-settings/general-settings.component.html
// module chunks = main